// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modulePages .card-wrapper {
display: inline-block;
perspective: 1000px;
}
@media only screen and (max-width: 600px) {
    .modulePages div[style] {
        width: 100% !important;
        /*height: 200px !important;*/
    }
}
.modulePages .card-wrapper .card {
position: relative;
cursor: pointer;
transition-duration: 0.6s;
transition-timing-function: ease-in-out;
transform-style: preserve-3d;
-webkit-transform-style: preserve-3d;
-moz-transform-style: preserve-3d;
-ms-transform-style: preserve-3d;
-webkit-backface-visibility: hidden; 
}
@media only screen and (max-width: 600px) {
    .modulePages .card-wrapper div[style] {
        width: 100% !important;
        /*height: 200px !important;*/
    }
}
.modulePages .card-wrapper .card .front,
.modulePages .card-wrapper .card .back {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
backface-visibility: hidden;
transform: rotateX(0deg);
padding: 20px;
}
.modulePages .card-wrapper .card .front {
z-index: 2;
}
.modulePages .card-wrapper .card .back,
.modulePages .card-wrapper.flip-right .card .back {
transform: rotateY(180deg);
}
.modulePages .card-wrapper.flip-left .card .back {
transform: rotateY(-180deg);
}
.modulePages .card-wrapper.flip-up .card .back {
transform: rotateX(180deg);
}
.modulePages .card-wrapper.flip-down .card .back {
transform: rotateX(-180deg);
}
.modulePages .card-wrapper.flip-diagonal-right .card .back {
transform: rotate3d(1, 1, 0, 180deg);
}
.modulePages .card-wrapper.flip-diagonal-left .card .back {
transform: rotate3d(1, 1, 0, -180deg);
}
.modulePages .card-wrapper.flip-inverted-diagonal-right .card .back {
transform: rotate3d(-1, 1, 0, 180deg);
}
.modulePages .card-wrapper.flip-inverted-diagonal-left .card .back {
transform: rotate3d(1, -1, 0, 180deg);
}

/* DEMO */
body {
background: #E7BDD6;
}
.modulePages .card-wrapper,
.modulePages .card {
min-width: 200px;
min-height: 200px;
margin: 10px;
border-radius: 16px !important;
}
.modulePages .card .front {
display: flex;
align-items: center;
justify-content: center;
border: 1px solid #ff8855;
border-radius: 16px;
}
.modulePages .card .back {
border: 1px solid #ff8855;
border-radius: 16px;
}
.modulePages .card .front {
color: #000000;
background: #FFFFFF;
font-weight: 700;
}
.modulePages .card .back {
color: #000000;
background: #DEECD5;
}
@media only screen and (max-width: 600px) {
    .modulePages .card-wrapper div[style] {
        margin: 0;
    }
    .modulePages .card-wrapper,
    .modulePages .card {
        margin:auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/flipCards.css"],"names":[],"mappings":"AAAA;AACA,qBAAqB;AACrB,mBAAmB;AACnB;AACA;IACI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;AACA;AACA,kBAAkB;AAClB,eAAe;AACf,yBAAyB;AACzB,uCAAuC;AACvC,4BAA4B;AAC5B,oCAAoC;AACpC,iCAAiC;AACjC,gCAAgC;AAChC,mCAAmC;AACnC;AACA;IACI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;AACA;;AAEA,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AAEZ,2BAA2B;AAC3B,wBAAwB;AACxB,aAAa;AACb;AACA;AACA,UAAU;AACV;AACA;;AAEA,0BAA0B;AAC1B;AACA;AACA,2BAA2B;AAC3B;AACA;AACA,0BAA0B;AAC1B;AACA;AACA,2BAA2B;AAC3B;AACA;AACA,oCAAoC;AACpC;AACA;AACA,qCAAqC;AACrC;AACA;AACA,qCAAqC;AACrC;AACA;AACA,qCAAqC;AACrC;;AAEA,SAAS;AACT;AACA,mBAAmB;AACnB;AACA;;AAEA,gBAAgB;AAChB,iBAAiB;AACjB,YAAY;AACZ,8BAA8B;AAC9B;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,yBAAyB;AACzB,mBAAmB;AACnB;AACA;AACA,yBAAyB;AACzB,mBAAmB;AACnB;AACA;AACA,cAAc;AACd,mBAAmB;AACnB,gBAAgB;AAChB;AACA;AACA,cAAc;AACd,mBAAmB;AACnB;AACA;IACI;QACI,SAAS;IACb;IACA;;QAEI,WAAW;IACf;AACJ","sourcesContent":[".modulePages .card-wrapper {\ndisplay: inline-block;\nperspective: 1000px;\n}\n@media only screen and (max-width: 600px) {\n    .modulePages div[style] {\n        width: 100% !important;\n        /*height: 200px !important;*/\n    }\n}\n.modulePages .card-wrapper .card {\nposition: relative;\ncursor: pointer;\ntransition-duration: 0.6s;\ntransition-timing-function: ease-in-out;\ntransform-style: preserve-3d;\n-webkit-transform-style: preserve-3d;\n-moz-transform-style: preserve-3d;\n-ms-transform-style: preserve-3d;\n-webkit-backface-visibility: hidden; \n}\n@media only screen and (max-width: 600px) {\n    .modulePages .card-wrapper div[style] {\n        width: 100% !important;\n        /*height: 200px !important;*/\n    }\n}\n.modulePages .card-wrapper .card .front,\n.modulePages .card-wrapper .card .back {\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\n-webkit-backface-visibility: hidden;\nbackface-visibility: hidden;\ntransform: rotateX(0deg);\npadding: 20px;\n}\n.modulePages .card-wrapper .card .front {\nz-index: 2;\n}\n.modulePages .card-wrapper .card .back,\n.modulePages .card-wrapper.flip-right .card .back {\ntransform: rotateY(180deg);\n}\n.modulePages .card-wrapper.flip-left .card .back {\ntransform: rotateY(-180deg);\n}\n.modulePages .card-wrapper.flip-up .card .back {\ntransform: rotateX(180deg);\n}\n.modulePages .card-wrapper.flip-down .card .back {\ntransform: rotateX(-180deg);\n}\n.modulePages .card-wrapper.flip-diagonal-right .card .back {\ntransform: rotate3d(1, 1, 0, 180deg);\n}\n.modulePages .card-wrapper.flip-diagonal-left .card .back {\ntransform: rotate3d(1, 1, 0, -180deg);\n}\n.modulePages .card-wrapper.flip-inverted-diagonal-right .card .back {\ntransform: rotate3d(-1, 1, 0, 180deg);\n}\n.modulePages .card-wrapper.flip-inverted-diagonal-left .card .back {\ntransform: rotate3d(1, -1, 0, 180deg);\n}\n\n/* DEMO */\nbody {\nbackground: #E7BDD6;\n}\n.modulePages .card-wrapper,\n.modulePages .card {\nmin-width: 200px;\nmin-height: 200px;\nmargin: 10px;\nborder-radius: 16px !important;\n}\n.modulePages .card .front {\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nborder: 1px solid #ff8855;\nborder-radius: 16px;\n}\n.modulePages .card .back {\nborder: 1px solid #ff8855;\nborder-radius: 16px;\n}\n.modulePages .card .front {\ncolor: #000000;\nbackground: #FFFFFF;\nfont-weight: 700;\n}\n.modulePages .card .back {\ncolor: #000000;\nbackground: #DEECD5;\n}\n@media only screen and (max-width: 600px) {\n    .modulePages .card-wrapper div[style] {\n        margin: 0;\n    }\n    .modulePages .card-wrapper,\n    .modulePages .card {\n        margin:auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
